import { t } from "i18next";
import moment from "moment";
import { Util } from "common/util";
import { getMany, softDeleteById } from "services/payroll";
import withDataTable from "./withDataTable";
const pathName = "/payrolls";

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = 1;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = JSON.stringify({
      column: ["name", "code"],
      value: searchStr,
    });
  }

  if (params.get("date")) {
    option["date"] = [params.get("date")];
  }

  if (params.get("projectId")) {
    option["projectId"] = params.get("projectId");
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  Util.getInstance().pushParamsToURL(pathName, queryParams.toString());
};

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);

  if (!params.get("date")) params.set("date", moment().format("YYYY-MM-DD"));

  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

export default withDataTable({
  title: t("text_payroll"),
  updateLink: "/payrolls/update",
  addImportLink: "/payrolls/import",
  addViewLink: "/payrolls/view",
  dateFormat: "MM/YYYY",
  pickerDate: "month",
  datePlaceholder: t("text_mm_yyyy"),
  topFilterItems: [],
  showPagination: true,
  showFilter: true,
  showAddNew: false,
  showDate: true,
  permission: "payroll",
  showProcessButton: true,
  showButtonInfo: true,
  showButtonUpdate: true,
  showButtonDelete: true,
  pathName,
  defaultCurrent,
  defaultPageSize,
  tableScrollY: window.innerHeight - 340,
  handleSearch,
  componentWillMount,
  getData,
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  confirmSoftDelete: (id) => softDeleteById(id),
});

